import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const DivergenceAndCurl = () => (
  <QPhototModuleSubtopic
    title="Divergence and curl"
    videos={[
      "https://www.youtube.com/embed/6o09h8pB7oY",
      "https://www.youtube.com/embed/kg6iSGIg4ww"
    ]}
    takeaways={[]}
    questions={[
        {
            image:"/cal_66.jpeg"
        },
        {
            image:"/cal_67.jpeg"
        },
        {
            image:"/cal_68.jpeg"
        },
        {
            image:"/cal_69.jpeg"
        },
    ]}
    exampleVideos={[]}
  />
);

export default DivergenceAndCurl;
